import React from "react";
import { Clock } from "@phosphor-icons/react";
import { DAYS, Panel, hourLabel } from "./dashUtils";

const LEVELS = ["#141414", "rgba(115,191,68,0.18)", "rgba(115,191,68,0.38)", "rgba(115,191,68,0.65)", "#73bf44"];
const level = (v, max) => (!v ? 0 : v >= max * 0.75 ? 4 : v >= max * 0.5 ? 3 : v >= max * 0.25 ? 2 : 1);

function topHours(hours) {
  return hours.map((n, h) => ({ h, n })).filter((x) => x.n).sort((a, b) => b.n - a.n).slice(0, 3);
}

export function PeakHeatmap({ data }) {
  const heat = data?.heatmap || Array.from({ length: 7 }, () => Array(24).fill(0));
  const max = Math.max(1, ...heat.flat());
  const peak = data?.peak;
  const top = topHours(data?.hours || []);
  return (
    <Panel title="Peak usage times" testid="peak-usage-heatmap" aside={<span className="text-[0.65rem] text-neutral-500">Brisbane time (AEST)</span>}>
      {peak ? (
        <div className="flex items-start gap-2.5 rounded-lg border border-[#73bf44]/25 bg-[#73bf44]/[0.06] px-3.5 py-2.5 mb-4" data-testid="peak-summary">
          <Clock size={16} className="text-[#73bf44] mt-0.5" weight="fill" />
          <div className="text-xs text-neutral-300 leading-relaxed">
            Busiest window: <span className="text-white font-semibold">{DAYS[peak.day]} {hourLabel(peak.hour)}–{hourLabel((peak.hour + 1) % 24)}</span> ({peak.count} question{peak.count === 1 ? "" : "s"})
            {top.length > 0 && <span className="block text-neutral-500">Busiest hours overall: {top.map((t) => `${hourLabel(t.h)} (${t.n})`).join(" · ")}</span>}
          </div>
        </div>
      ) : (
        <p className="text-xs text-neutral-600 mb-4">No questions in this range yet.</p>
      )}
      <div className="overflow-x-auto">
        <div className="min-w-[520px]">
          <div className="grid grid-cols-[34px_repeat(24,minmax(0,1fr))] gap-[3px]">
            {DAYS.map((d, di) => (
              <React.Fragment key={d}>
                <div className="text-[0.62rem] text-neutral-500 flex items-center">{d}</div>
                {heat[di].map((v, h) => (
                  <div key={h} title={`${d} ${hourLabel(h)}–${hourLabel((h + 1) % 24)}: ${v} question${v === 1 ? "" : "s"}`}
                    data-testid={`heat-cell-${di}-${h}`}
                    className="h-6 rounded-[3px] transition-transform hover:scale-125 hover:ring-1 hover:ring-white/40"
                    style={{ backgroundColor: LEVELS[level(v, max)] }} />
                ))}
              </React.Fragment>
            ))}
            <div />
            {Array.from({ length: 24 }, (_, h) => (
              <div key={h} className="text-[0.55rem] text-neutral-600 text-center pt-1">{h % 3 === 0 ? hourLabel(h) : ""}</div>
            ))}
          </div>
          <div className="flex items-center justify-end gap-1.5 mt-3 text-[0.6rem] text-neutral-500">
            Less {LEVELS.map((c) => <span key={c} className="w-3 h-3 rounded-[3px] inline-block" style={{ backgroundColor: c }} />)} More
          </div>
        </div>
      </div>
    </Panel>
  );
}
